import SectionDescription from './SectionDescription';
export default SectionDescription;
